export default {"src":"/_next/static/media/PersonalizedRecoveryPlans.840c26d9.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};